import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'src/components/shared/Button/Button';
import { Header1 } from 'src/components/shared/Typography/Header1';
import { useAuth } from '../Auth/AuthContext';

const Unauthorized: React.FC = () => {
  const { t } = useTranslation();
  const { signin } = useAuth();

  const onLogin = () => {
    signin();
  };

  return (
    <>
      <Header1>{t('error.unauthorizedHeader')}</Header1>
      <p>{t('error.unauthorizedMessage')}.</p>

      <hr />

      <PrimaryButton onClick={onLogin}>{t('signin')}</PrimaryButton>
    </>
  );
};

export default Unauthorized;
